"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.breakpointNumbers = void 0;
var _styles = require("@material-ui/core/styles");
var _config = _interopRequireDefault(require("./config"));
var breakpointNumbers = {
  sm: 960,
  md: 1024,
  lg: 1440,
  xl: 1920
};
exports.breakpointNumbers = breakpointNumbers;
var theme = (0, _styles.createTheme)({
  palette: {
    type: 'light',
    primary: {
      main: _config["default"].brandColors.primary,
      800: '#134050',
      700: '#215265',
      600: '#2F667B',
      500: '#3B748B',
      400: '#58899E',
      300: '#729EB2',
      200: '#96BACB',
      100: '#B8D8E5',
      50: '#DAF0FE'
    },
    secondary: {
      main: '#0073DD',
      900: '#0043AA',
      800: '#0062CB',
      700: '#0073DD',
      600: '#0085F0',
      500: '#0093FE',
      400: '#1FA3FF',
      300: '#54B3FE',
      200: '#89C9FE',
      100: '#B8DDFE',
      50: '#E2F2FE'
    }
  },
  text: {
    labelEmphasis: {
      medium: 'rgba(0, 43, 58, 0.74)'
    },
    surfaceEmphasis: {
      high: 'rgba(0, 0, 0, 0.87)',
      medium: 'rgba(0, 0, 0, 0.60)',
      disabled: 'rgba(0, 0, 0, 0.38)'
    },
    primaryEmphasis: {
      high: 'rgba(255, 255, 255, 1)',
      medium: 'rgba(255, 255, 255, 0.60)',
      disabled: 'rgba(255, 255, 255, 0.38)'
    }
  },
  typography: {
    useNextVariants: true
  },
  breakpoints: {
    values: {
      sm: "".concat(breakpointNumbers.sm, "px"),
      md: "".concat(breakpointNumbers.md, "px"),
      lg: "".concat(breakpointNumbers.lg, "px"),
      xl: "".concat(breakpointNumbers.xl, "px")
    }
  }
});
exports.theme = theme;